import { ApiKeyEntity, FirestoreEntity, Mapper } from '../../..';
import { ApiKey } from '../models/api-key.model';

export class ApiKeyEntityToApiKeyMapper implements Mapper<FirestoreEntity<ApiKeyEntity>, ApiKey> {
  public map(from: FirestoreEntity<ApiKeyEntity>): ApiKey {
    return new ApiKey(
      from.id,
      from.data.teamId,
      from.data.hash,
      from.data.status,
      from.data.createdAt.toDate(),
      from.data.createdBy,
      from.data.updatedAt.toDate(),
      from.data.lastUsedAt ? from.data.lastUsedAt.toDate() : undefined,
    );
  }
}
